import React, { Component } from 'react';
import isAfter from 'date-fns/is_after';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './DateBar.styles';

import Button from '../../inputs/button/Button';
import DateInput from '../../inputs/date/DateInput';

export class DateBar extends Component {
  constructor(props){
    super(props);
    let s = {};
    if(props.startDate){
      s.startDate = props.startDate;
    }else{
      let st = new Date();
      st.setHours(st.getHours() - 1);
      s.startDate = st
    }
    if(props.endDate){
      s.endDate = props.endDate;
    }else{
      s.endDate = new Date();
    }
    this.state = s;
  }
  handleChangeStartDate = ({ value }) => {
    this.setState({ startDate: value });
  };
  handleChangeEndDate = ({ value }) => {
    this.setState({ endDate: value });
  };
  render() {
    const invalidDates = isAfter(this.state.startDate, this.state.endDate);
    return (
      <div className={css(styles.base)}>
        <label className={css(styles.input)}>
          <span className={css(styles.label)}>
            <Translate value="add.history.startDate" />
          </span>
          <DateInput
            value={this.state.startDate}
            onChange={this.handleChangeStartDate}
            dateFormat="mm/dd/yy"
            maxDate={new Date()}
          />
        </label>
        <label className={css(styles.input)}>
          <span className={css(styles.label)}>
            <Translate value="add.history.endDate" />
          </span>
          <DateInput
            value={this.state.endDate}
            onChange={this.handleChangeEndDate}
            dateFormat="mm/dd/yy"
            maxDate={new Date()}
          />
        </label>
        <Button
          disabled={invalidDates}
          styles={styles.button}
          onClick={() => {
            this.props.handleClick(this.state.startDate, this.state.endDate);
          }}
        >
          <Translate value={this.props.buttonText || 'submit'} />
        </Button>
        {invalidDates && (
          <Translate
            className={css(styles.error)}
            value="error.invalidDateRange"
          />
        )}
      </div>
    );
  }
}

export default DateBar;



// WEBPACK FOOTER //
// ./src/components/common/datebar/DateBar.js